export const actions = {
  resetRequest: (type: string, requestKey?: string) => ({
    type: 'RESET_REQUEST',
    actionType: type,
    requestKey,
  }),
}
